export const ADDON_STORM_DIALER_SINGLE = 'storm-dialer-single';
export const ADDON_STORM_DIALER_MULTI = 'storm-dialer-multi';
export const ADDON_STORM_DIALER_SINGLE_PER_UNIT = 'storm-dialer-single-per-unit';
export const ADDON_STORM_DIALER_MULTI_PER_UNIT = 'storm-dialer-multi-per-unit';
export const ADDON_STORM_DIALER_SINGLE_MONTHLY_BUNDLE = 'storm_dialer_single_monthly_bundle';
export const ADDON_STORM_DIALER_SINGLE_ANNUAL_BUNDLE = 'storm_dialer_single_annual_bundle';
export const MULTI_DIALER_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line';
export const SINGLE_DIALER_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-single-line';
export const MULTI_DIALER_PER_UNIT_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line-per-unit';
export const SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-single-line-per-unit';
export const MULTI_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line-monthly-bundle';
export const SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-single-line-monthly-bundle';
export const MULTI_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line-annual-bundle';
export const SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-single-line-annual-bundle';
export const MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line-crm-premier';
export const ADDON_LANDING_PAGES_ANNUAL = 'landing-pages-annual';
export const ADDON_LANDING_PAGES_MONTHLY = 'landing-pages-monthly';
export const ADDON_LANDING_PAGES_ANNUAL_PER_UNIT = 'landing-pages-annual-per-unit';
export const ADDON_LANDING_PAGES_MONTHLY_PER_UNIT = 'landing-pages-monthly-per-unit';
export const ADDON_LANDING_PAGES_ANNUAL_BUNDLE = 'landing-pages-annual-bundle';
export const ADDON_LANDING_PAGES_MONTHLY_BUNDLE = 'landing-pages-monthly-bundle';
export const LANDING_PAGES_ANNUAL_COUPON = 'landing-pages-annual-promo';
export const PREMIER_MONTHLY_CHARGEBEE_ID = 'plan-liondesk-v2-crm-premier-monthly';
export const PREMIER_ANNUAL_CHARGEBEE_ID = 'plan-liondesk-v2-crm-premier-annual';
export const SINGLE_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-multi-line-monthly-promote-agent-bundle';
export const MULTI_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID = 'liondesk-power-dialer-wavv-single-line-monthly-promote-agent-bundle';
export const ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT = 'landing-pages-monthly-promote-agent-bundle';

export const MAP_DIALER_ADDON_CHARGEBEE_ID = {
  [ADDON_STORM_DIALER_SINGLE]: SINGLE_DIALER_CHARGEBEE_ID,
  [ADDON_STORM_DIALER_MULTI]: MULTI_DIALER_CHARGEBEE_ID,
  [ADDON_STORM_DIALER_SINGLE_PER_UNIT]: SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
  [ADDON_STORM_DIALER_MULTI_PER_UNIT]: MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
  [ADDON_STORM_DIALER_SINGLE_MONTHLY_BUNDLE]: SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
  [ADDON_STORM_DIALER_SINGLE_ANNUAL_BUNDLE]: SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
};

export const MONTHLY_ADDON_PLACEHOLDER = 'plan-liondesk-addon-placeholder';
export const STATUS_ADDON_ACTIVE = 'active';
export const STATUS_CANCELLED_PENDING = 'cancelled_pending';
export const STATUS_PAUSED_PENDING = 'paused_pending';
export const STATUS_FREE = 'free';
export const VALID_ADDON_STATUS_LIST = [
  STATUS_ADDON_ACTIVE,
  STATUS_CANCELLED_PENDING,
  STATUS_PAUSED_PENDING,
  STATUS_FREE,
];
export const STATUS_ADDON_CANCELLED = 'cancelled';

export const ADDON_PLANS = [
  // TODO EP we should move this logic to the backend and have an endpoint to fetch it.
  {
    id: ADDON_STORM_DIALER_SINGLE,
    price: 99,
    planName: 'Single Line',
  },
  {
    id: ADDON_STORM_DIALER_MULTI,
    price: 149,
    planName: 'Multi Line',
  },
  {
    id: ADDON_STORM_DIALER_SINGLE_PER_UNIT,
    price: 99,
    planName: 'Single Line',
  },
  {
    id: ADDON_STORM_DIALER_MULTI_PER_UNIT,
    price: 149,
    planName: 'Multi Line',
  },
  {
    id: ADDON_LANDING_PAGES_MONTHLY,
    price: 29,
    planName: 'Landing Pages Monthly',
  },
  {
    id: ADDON_LANDING_PAGES_ANNUAL,
    price: 197,
    planName: 'Landing Pages Annual',
  },
];

export const CC_EXPIRED_PENDING_STATUS = 'ccexpired_pending';
export const CC_EXPIRED_STATUS = 'ccexpired';

export function hasExpiredCC(user) {
  return (
    user.subscriptionOverview.txt_status === CC_EXPIRED_PENDING_STATUS
    || user.subscriptionOverview.txt_status === CC_EXPIRED_STATUS
  );
}

export const LIONDESK_STAFF_CHARGEBEE_ID = 'LionDesk_Staff';
export const BOLDLEADS_STAFF_CHARGEBEE_ID = 'BoldLeads_Staff';
export const LEADSPLUS_STAFF_CHARGEBEE_ID = 'LeadsPlus_Staff';

export function isLionDeskStaff(user) {
  return [
    LIONDESK_STAFF_CHARGEBEE_ID,
    BOLDLEADS_STAFF_CHARGEBEE_ID,
    LEADSPLUS_STAFF_CHARGEBEE_ID,
  ].includes(user.subscriptionOverview.id_chargebee.String);
}

export function isPremierMonthlyPlan(user) {
  return user && user.subscriptionOverview && user.subscriptionOverview.details.id_item === PREMIER_MONTHLY_CHARGEBEE_ID;
}

export function isPremierAnnualPlan(user) {
  return user && user.subscriptionOverview && user.subscriptionOverview.details.id_item === PREMIER_ANNUAL_CHARGEBEE_ID;
}
